import _ from 'lodash';
import {
    TSerialisedAddresses,
    TSerialisedPeople,
    TSerialisedPerson
} from './PersonModal.types';

export function deserialiseAddresses(addresses: TSerialisedAddresses) {
    return _.map(addresses, (address, index) => {
        if (index === 0) {
            _.assign(address, { isPrimaryAddress: true });
        }

        return address;
    });
}

export function buildPeopleBody(
    people: TSerialisedPeople,
    serialisedPerson: TSerialisedPerson
) {
    const isEditingPerson = !!_.find(people, { uid: serialisedPerson.uid });

    if (isEditingPerson) {
        return _.chain(people)
            .map((person) =>
                person.uid === serialisedPerson.uid
                    ? _.assign({}, person, serialisedPerson)
                    : person
            )
            .value();
    } else {
        return people.concat([serialisedPerson]);
    }
}

export function removePerson(people: TSerialisedPeople, uid: string) {
    return _.filter(people, (person) => person.uid !== uid);
}
